module.exports = __webpack_public_path__ + "img/scissors.d1986efa.svg";